import Default from './Default.vue';
export default Default;


// WEBPACK FOOTER //
// ./src/components/parts/rating/default/index.js